import React, { createContext, useContext, useState } from 'react';

const RateLimitContext = createContext(null);

export const useRateLimit = () => {
  const context = useContext(RateLimitContext);
  if (!context) {
    throw new Error('useRateLimit must be used within RateLimitProvider');
  }
  return context;
};

export const RateLimitProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);

  const showRateLimitModal = () => {
    setShowModal(true);
  };

  const hideRateLimitModal = () => {
    setShowModal(false);
  };

  return (
    <RateLimitContext.Provider value={{ showModal, showRateLimitModal, hideRateLimitModal }}>
      {children}
    </RateLimitContext.Provider>
  );
};
